module.exports = __webpack_public_path__ + "img/16m005-09.f4b6fba9.png";